export default {
    CONSULTA: 1,
    RETORNO: 2,
}